import { motion, Transition } from 'motion/react';
import tw, { styled, TwStyle } from 'twin.macro';

export type BorderTrailProps = {
  wrapperStyles?: TwStyle[];
  twStyles?: TwStyle[];
  size?: number;
  transition?: Transition;
  onAnimationComplete?: () => void;
  style?: React.CSSProperties;
};

export function BorderTrail({
  twStyles,
  wrapperStyles,
  transition,
  onAnimationComplete,
  style,
  size = 60,
}: BorderTrailProps) {
  const defaultTransition: Transition = {
    repeat: Infinity,
    duration: 5,
    ease: 'linear',
  };

  return (
    <Wrapper twStyles={wrapperStyles}>
      <StyledMotionWrapper
        style={{
          width: size,
          offsetPath: `rect(0 auto auto 0 round ${size}px)`,
          ...style,
        }}
        animate={{
          offsetDistance: ['0%', '100%'],
        }}
        transition={transition || defaultTransition}
        onAnimationComplete={onAnimationComplete}
        $twStyles={twStyles}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div<{ twStyles?: TwStyle[] }>`
  ${tw`pointer-events-none absolute inset-0 rounded-[inherit] border border-transparent [mask-clip:padding-box,border-box] [mask-composite:intersect] [mask-image:linear-gradient(transparent,transparent),linear-gradient(#000,#000)]`}
  ${({ twStyles }) => twStyles || []}
`;
const StyledMotionWrapper = styled(motion.div)<{ $twStyles?: TwStyle[] }>`
  ${tw`absolute aspect-square bg-zinc-500`}
  ${({ $twStyles }) => $twStyles || []}
`;
